import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import LocationMap from '../DataguardLocationMap';
import { GET_LOCATION_SUMMARY, renderFlag } from '../../Utility/DataguardConstant';
import Page_Loader from '../../../../assets/vizr_images/page_loader.gif';
import { getCountryCode, getFlagUrl } from '../../../SysGuard/Dashboard/ContentPages/SysGuardColumnConfig';
import { formatNumber } from '../../Utility/DataguardConstant';
import TimelineIcon from '@material-ui/icons/Timeline';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import FullscreenIcon from "@material-ui/icons/Fullscreen";

const LocationCard = ({ showExpandedView, isPopup = false, onClick, style }) => {
  const dispatch = useDispatch();
  const [totalLocation, setTotalLocation] = useState(0);
  const [totalAlerts, setTotalAlerts] = useState(0);
  const [top3Titles, setTop3Titles] = useState([]);

  const locationSummary = useSelector(
    (state) => state.DataguardReducer.locationSummary
  );
  const fromTimeStamp = useSelector((state) => state.DataguardReducer.fromTimeStamp);
  const toTimeStamp = useSelector((state) => state.DataguardReducer.toTimeStamp);
  const locationSummaryLoader = useSelector((state) => state.DataguardReducer.locationSummaryLoader);

  useEffect(() => {
    if (fromTimeStamp && toTimeStamp) {
      dispatch({
        type: GET_LOCATION_SUMMARY, payload: {
          fromTimeStamp,
          toTimeStamp
        }
      });
    }
  }, [dispatch, fromTimeStamp, toTimeStamp]);

  useEffect(() => {
    if (locationSummary) {
      setTotalLocation(locationSummary.noOfLocations || 0);
      setTop3Titles(locationSummary.topLocations || []);
      setTotalAlerts(locationSummary.locationAlerts || 0);
    }
  }, [locationSummary]);

  return (
    <div className="column-card locations-card" style={style}>
      <div className='details-container' onClick={onClick}>
        <div className='left-details'>
          <div className='left-details-container'>
            <div className='icon-container'>
              <img src='/dataguardIcons/location.svg' alt='Location Icon' />
              <span className='ico-label'>Locations</span>
            </div>
            <div className='left-details-txt'>
              <span># of Locations</span>
              <span className='no-locs' title={totalLocation}>{formatNumber(totalLocation)}</span>
            </div>
            <div className='left-details-txt'>
              <span>Location Alert</span>
              <span className='loc-alert' title={totalAlerts}>{formatNumber(totalAlerts)}</span>
            </div>
            <div className='activity-txt'>
              <span className='ico-label' title='Activities from Top 3 Locations'>Top 3 Locations</span>
            </div>
            <div className='lst-container'>
              {top3Titles.map((item, index) => (
                <div key={index} className='lst-item' title={item.countryOrCity}>
                  {renderFlag(item.countryOrCity)}
                  <span className='loc-name' title={item.countryOrCity}>
                    {item.countryOrCity}
                  </span>
                  <span className='loc-access-stats' title='Access Count' >
                    <TimelineIcon />
                    <span title={item.accessCount.toLocaleString('en-US')}>({formatNumber(item.accessCount)})</span>
                  </span>
                  <span className='loc-user-stats' title='Users Count'>
                    <PeopleAltIcon />
                    <span title={item.userCount.toLocaleString('en-US')}>({formatNumber(item.userCount)})</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='right-chart'>
          {locationSummaryLoader ? (
            <div className='loader-container'>
              <img src={Page_Loader} alt="Loading..." className='loader-img' />
            </div>
          ) : (
            <LocationMap loc={isPopup ? 'dashboardPopup' : 'default'} />
          )}
        </div>
      </div>
      {!isPopup ? (
        <div className='fullscreen-icon location' onClick={(e) => {showExpandedView('locations');e.stopPropagation();}}>
          <FullscreenIcon fontSize="small"/>
        </div>
      ) : (
        null
      )}
    </div>
  );
};

export default LocationCard;